export default Object.freeze({
  /**
   * 토큰 갱신
   */
  "/auth/refresh": {
    path: "/app/{0}/mall/{1}/auth/refresh",
    method: "GET",
  },
  /**
   * 포인트-판매-업체-정보
   */
  "/get/mileage/usage": {
    path: "/app/{0}/mall/{1}/api/mileage/usage",
    method: "GET",
  },

  /**
   * 설정된-포인트-상품-개수
   */
  "/get/mileage/count": {
    path: "/app/{0}/mall/{1}/api/mileage/count",
    method: "GET",
  },

  /**
   * 판매 현황 조회
   */
  "/get/mileage/sales": {
    path: "/app/{0}/mall/{1}/api/mileage/sales",
    method: "GET",
  },

  /**
   * 포인트 판매 설정 > 포인트 상품 저장
   */
  "/post/mileage/products": {
    path: "/app/{0}/mall/{1}/api/mileage/products",
    method: "POST",
  },
  /**
   * 포인트 판매 설정 > 포인트 상품 수정
   */
  "/put/mileage/products": {
    path: "/app/{0}/mall/{1}/api/mileage/products/{2}",
    method: "PUT",
  },

  /**
   * 포인트 판매 설정 > 포인트 상품 조회
   */
  "/get/mileage": {
    path: "/app/{0}/mall/{1}/api/mileage/products",
    method: "GET",
  },

  /**
   * 포인트 판매 설정 > 포인트-상품-진열-상태-수정
   */
  "/put/mileage/display": {
    path: "/app/{0}/mall/{1}/api/mileage/products/{2}/display",
    method: "PUT",
  },

  /**
   * 포인트 판매 설정 > 포인트-상품-판매-상태-수정
   */
  "/put/mileage/selling": {
    path: "/app/{0}/mall/{1}/api/mileage//products/{2}/selling",
    method: "PUT",
  },

  /**
   * 포인트 판매 설정 > 포인트-상품-삭제
   */
  "/delete/mileage/products": {
    path: "/app/{0}/mall/{1}/api/mileage/products/{2}",
    method: "DELETE",
  },

  /**
   * 포인트 판매 설정 > 쇼핑몰-화면-설정-PC-화면-설정-조회
   */
  "/get/mileage/config/desktop": {
    path: "/app/{0}/mall/{1}/api/mileage/config/desktop",
    method: "GET",
  },

  /**
   * 포인트 판매 설정 > 쇼핑몰-화면-설정-PC-화면-설정-저장
   */
  "/put/mileage/config/desktop": {
    path: "/app/{0}/mall/{1}/api/mileage/config/desktop",
    method: "PUT",
  },
  /**
   * 포인트 판매 설정 > 쇼핑몰-화면-설정-모바일-화면-설정-조회
   */
  "/get/mileage/config/mobile": {
    path: "/app/{0}/mall/{1}/api/mileage/config/mobile",
    method: "GET",
  },

  /**
   * 포인트 판매 설정 > 쇼핑몰-화면-설정-모바일-화면-설정-저장
   */
  "/put/mileage/config/mobile": {
    path: "/app/{0}/mall/{1}/api/mileage/config/mobile",
    method: "PUT",
  },

  /**
   * 포인트 판매 설정 > 쇼핑몰-화면-설정-모바일-화면-설정-저장
   */
  "/get/mileage/config/html": {
    path: "/app/{0}/mall/{1}/api/mileage/config/html",
    method: "GET",
  },

  /**
   * 포인트 상품 주문 목록 > 조회
   */
  "/get/mileage/orders": {
    path: "/app/{0}/mall/{1}/api/mileage/orders/products",
    method: "GET",
  },

  /**
   * 어드민:결제-관리-결재-내역-조회
   */
  "/get/orders": {
    path: "/app/{0}/mall/{1}/api/mileage/orders/payments",
    method: "GET",
  },

  /**
   * 어드민:포인트-결제-서비스-결제-관리-결제하기
   */
  "/post/orders": {
    path: "/app/{0}/mall/{1}/api/mileage/orders",
    method: "POST",
  },

  /**
   * 어드민:포인트-상품-결제-관리-개월수-조회
   */
  "/get/orders/types": {
    path: "/app/{0}/mall/{1}/api/mileage/orders/types",
    method: "GET",
  },

  /**
   * 결제 관리 입력 정보 조회
   */
  "/get/orders/latest": {
    path: "/app/{0}/mall/{1}/api/mileage/orders/latest",
    method: "GET",
  },

  /**
   * 결제 관리 입력 정보 등록
   */
  "/post/orders/latest": {
    path: "/app/{0}/mall/{1}/api/mileage/orders/latest",
    method: "POST",
  },
});
